import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '@/configuration/setup/store';

interface MfeDialogPayload {
    title: string;
    url: string;
}

interface MfeDialogState {
    isOpen: boolean;
    title: string | null;
    url: string | null;
}

const initialState: MfeDialogState = {
    isOpen: false,
    title: null,
    url: null,
};

const mfeDialogSlice = createSlice({
    name: 'mfeDialog',
    initialState,
    reducers: {
        openMfeDialog: (state, action: PayloadAction<MfeDialogPayload>) => {
            state.isOpen = true;
            state.title = action.payload.title;
            state.url = action.payload.url;
        },
        closeMfeDialog: (state) => {
            state.isOpen = false;
            state.title = null;
            state.url = null;
        },
    },
});

// Actions
export const { openMfeDialog, closeMfeDialog } = mfeDialogSlice.actions;

// Selectors
export const getMfeDialogIsOpen = (state: RootState) => state.mfeDialog.isOpen;
export const getMfeDialogTitle = (state: RootState) => state.mfeDialog.title;
export const getMfeDialogUrl = (state: RootState) => state.mfeDialog.url;

export default mfeDialogSlice.reducer;
